
import PageLoading from '@/components/Shared/Loading/Preloader.vue'
export default {
  middleware: ['returnUrl', 'onlyRedirectProject'],
  async fetch({ store, app }) {
    const currency = store.getters['user/getUserIP'].currency
    await store.dispatch('popularProducts/GET_POPULAR_PRODUCTS', {
      currency,
      lang: app.i18n.locale,
    })
  },
  async asyncData({ store, route, redirect }) {
    const [baseUrl, ids, domain] = route.params.productId.split('-')
    const types = require('@/static/database/Types.json')
    const id = Number(ids)
    if (isNaN(id)) redirect('/error')
    const response = await store.dispatch('productDetail/GET_PRODUCT_TO_LIST', {
      url: `${baseUrl}/${id}?currency=${store.getters['user/getUserIP'].currency}`,
      id,
    })
    const product = response
      ? response
      : store.getters['productDetail/getProduct'](id)
    const activeComponent = types.find((t) => t.to === baseUrl).component
    return {
      activeComponent,
      product,
      type: types.find((t) => t.to === baseUrl),
    }
  },
  head() {
    return {
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
      title:
        `${this.product.title}  - ${this.$custom$t(`type.${this.type.name}`)}` +
        ' | ' +
        this.$store.state.settings.title,
      link: [
        {
          hid: 'canonical',
          rel: 'canonical',
          href: this.$store.state.settings.website + this.$route.path,
        },
        {
          hid: 'icon',
          rel: 'icon',
          type: 'image/x-icon',
          href: this.$store.state.settings.noImage,
        },
      ],
      meta: [
        { hid: 'og-type', property: 'og:type', content: 'website' },
        {
          hid: 'title',
          property: 'title',
          content:
            `${this.product.title}` + ' | ' + this.$store.state.settings.title,
        },
        {
          hid: 'og:site_name',
          property: 'og:site_name',
          content: this.$store.state.settings.title,
        },
        {
          hid: 'description',
          name: 'description',
          content: this.product.description.substring(0, 152),
        },
        {
          hid: 'og-title',
          property: 'og:title',
          content:
            `${this.product.title}` + ' | ' + this.$store.state.settings.title,
        },
        {
          hid: 'og-desc',
          property: 'og:description',
          content: this.product.description.substring(0, 152),
        },
        {
          hid: 'og-image',
          property: 'og:image',
          content: this.$api.path(this.product.imagePath),
        },
        {
          hid: 'og-url',
          property: 'og:url',
          content:
            this.$store.state.settings.contents[this.$i18n.locale].seo.home
              .url + `/${this.type.to}-${this.product.id}`,
        },
        { hid: 't-type', name: 'twitter:card', content: 'summary_large_image' },
      ],
      script: [
        ...this.$store.state.settings.analyticSettings
          .filter((as) => as.key === 'script' && as.source === null)
          .map((asettings) => ({
            type: 'text/javascript',
            innerHTML: asettings.value,
          })),
        ...this.$store.state.settings.analyticSettings
          .filter((as) => as.key === 'script' && as.source !== null)
          .map((asettings) => ({
            type: 'text/javascript',
            src: asettings.source,
            innerHTML: asettings.value,
          })),
      ],
      __dangerouslyDisableSanitizers: ['script'],
    }
  },
  computed: {
    pageIsLoading() {
      return this.$store.state.productDetail.productListIsLoading
    }
  },
  components: {
    PageLoading,
    CourseContent: () => import('@/components/Contents/CourseContent'),
    BookContent: () => import('@/components/Contents/BookContent'),
    EventContent: () => import('@/components/Contents/EventContent'),
    SeanceContent: () => import('@/components/Contents/SeanceContent'),
    BlogContent: () => import('@/components/Contents/BlogContent'),
  },
}
